import { useEffect, useRef, useState } from "react";
import { useDebounce } from "./lib";
import { useMutation } from "@tanstack/react-query";
import { checkCode } from "../../../Services/Api";
import useSound from "use-sound";
import err from '../sounds/err.mp3';
import saveSucsess from '../sounds/saveSucsess.mp3';
import { Button, TextField, Typography } from "@mui/material";


const NUMBER_OF_KMS = 10; // Количество товаров в упаковке, которое нужно отсканировать для перехода на следующий этап

export const Stage2 = (props) => {
  const {
    setRezult = () => { },
    initialKms = [],
    stateSave = () => { },
    barCode,
    productName,
    aggrCode,
    boxSize,
    aggLevelId, 
  } = props;
  const [playErr] = useSound(err);
  const [playSaveSucsess] = useSound(saveSucsess);

  const codeFieldRef = useRef(null);
  const [code, setCode] = useState('');
  const [kms, setKms] = useState(initialKms);
  const kmsRef = useRef(null)
  const [errorMessage, setErrorMessage] = useState('');
  kmsRef.current = kms;

  useEffect(() => {
    if (kms.length >= boxSize) {
      setRezult(kms);
    } else {
      stateSave(kms);
    }
  }, [kms]);


  const clear = () => {
    setCode('');
    if (codeFieldRef.current) {
      codeFieldRef.current.focus();
    }
  }
  useEffect(() => {
    clear();
    setErrorMessage('');
  }, []);

  const mutation = useMutation({
    mutationFn: checkCode,
    onSuccess: (data) => {
      if (data?.payload?.status === 'ok' && data?.payload?.km) {
        if (kmsRef.current?.includes(data?.payload?.km)) {
          setErrorMessage(`Этот код ("${data?.payload?.km}") уже отсканирован`);
          clear();
          playErr();
        } else {
          setKms((prevKms) => [...prevKms, data?.payload?.km]);
          playSaveSucsess();
          clear();
          setErrorMessage('');
        }
      } else {
        clear();
        setErrorMessage(data?.payload?.resultMessage || 'Ошибка проверки кода');
        playErr();
      }
      console.log('!!!Code check successful:', data?.payload?.status);
    },
    onError: (error) => {
      playErr();
      console.error('!!!Code check failed:', error);
      clear();
      setErrorMessage(error?.message ? (`Сетевая ошибка: ${error.message}`) : 'Непредвиденная сетевая ошибка');
    },
  });

  useDebounce(code, 200, (dValue) => {
    if (dValue) {
      console.log('!!!eq check', dValue, JSON.parse(JSON.stringify(dValue)), kms, kms.includes(dValue), kms.includes(JSON.parse(JSON.stringify(dValue))))
      if (kms.includes(dValue) || kmsRef.current?.includes(dValue)) {
        setErrorMessage(`Этот код ("${dValue}") уже отсканирован`);
        clear();
        playErr();

      } else {
        mutation.mutate({ km: dValue, aggrCode, barCode, aggLevelId });
      }
    }
  });

  const onClickFinish = () => {
    if (window.confirm('Подтвердите что хотите закрыть не полную упакуовку')) {
      setRezult(kms)
    }

  }


  return (
    <div >
      <div style={{ height: "20px", width: '100%', backgroundColor: "#22EEEE" }} >2</div>
      <Typography variant="body1" gutterBottom>
        Наполнение упаковки: Просканируйте все коды ЧЗ для данной упаковки. Агрегационный код: "{aggrCode}", название продукта: "{productName}"
      </Typography>
      <TextField
        inputRef={codeFieldRef}
        InputLabelProps={{ shrink: true }}
        label="ЧЗ код товара"
        fullWidth
        size="small"
        value={code}
        onChange={(e) => setCode(e?.target?.value || e)}
        error={!!errorMessage}
        helperText={!!errorMessage ? errorMessage : undefined}
      />
      {/* 

        {errorMessage && <div style={{ color: 'red' }}>{errorMessage}</div>}
        <input
          style={{ width: "100%" }}
          ref={codeFieldRef}
          type="text"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          placeholder="Отсканируйте код"
        /> */}
      <Button
        variant="contained"
        color="warning"
        disabled={!kms?.length}
        onClick={onClickFinish}
      >
        Закончить не полную упаковку
      </Button>
      {/* <div><button disabled={!kms?.length} onClick={() => setRezult(kms)}>Закончить не полную упаковку</button></div> */}
      <div>
        <Typography variant="body2" gutterBottom>
          Отсканировано для этой упаковки: {kms.length}, осталось: {boxSize - kms.length}, всего в упаковке: {boxSize}
        </Typography>
        {/* </div>
      <div> */}
        <ol>
          {kms.map((km, index) => (
            <Typography key={index} component="li" variant="body2">
              {km}
            </Typography>
          ))}
        </ol>
      </div>
    </div>
  );
}